import { Costs, FlipResultDTO } from 'utils/types/SaleModels';

import { stringToNumber } from './stringToNumber';

const normalizeFlipCosts = (costs?: Costs) => {
    if (!costs) return undefined;

    return {
        notary: stringToNumber(costs.notary),
        broker: stringToNumber(costs.broker),
        maintenanceFees: stringToNumber(costs.maintenanceFees),
        rentFees: stringToNumber(costs.rentFees),
        saleBroker: stringToNumber(costs.saleBroker),
        tax: stringToNumber(costs.tax),
        portalFees: stringToNumber(costs.portalFees),
        photographerAmount: stringToNumber(costs.photographerAmount),
        userOption: stringToNumber(costs.userOption),
        pcc: stringToNumber(costs.pcc),
        sumOfCosts: stringToNumber(costs.sumOfCosts),
        renovationFrom1To30Amount: stringToNumber(costs.renovationFrom1To30Amount),
        renovationFrom30To40Amount: stringToNumber(costs.renovationFrom30To40Amount),
        renovationFrom40To50Amount: stringToNumber(costs.renovationFrom40To50Amount),
        renovationFrom50To60Amount: stringToNumber(costs.renovationFrom50To60Amount),
        renovationFrom60PlusAmount: stringToNumber(costs.renovationFrom60PlusAmount)
    };
};

export const normalizeFlipResult = (flipResult?: FlipResultDTO) => {
    if (!flipResult) return undefined;

    return {
        isIndividualFlip: flipResult.isIndividualFlip,
        maxPurchasePrice: stringToNumber(flipResult.maxPurchasePrice),
        margin: stringToNumber(flipResult.margin),
        profit: stringToNumber(flipResult.profit),
        realPrice: stringToNumber(flipResult.realPrice),
        certainPrice: stringToNumber(flipResult.certainPrice),
        flipCosts: normalizeFlipCosts(flipResult.costs)
    };
};
